import mixins from 'vue-typed-mixins';
import _ from 'lodash';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '@codequality/vue-cli-base';

import { 計画書データApi, 計画書データListItemResponse, 計画書データ表示設定Request } from '@/openapi/user';

import AlertMixin from '@/mixins/AlertMixin';
import 計画書Mixin from '@/entries/user/mixins/計画書Mixin';

import UserApiUtility from '@/classes/common/UserApiUtility';

export default mixins(AlertMixin, 計画書Mixin).extend({
  name: 'M計画書データ表示設定Mixin',

  data(): {
    api: 計画書データApi;
  } {
    return {
      api: UserApiUtility.ogApi(計画書データApi),
    };
  },

  methods: {
    async save計画書データ表示設定(request: 計画書データ表示設定Request): Promise<void> {
      // 更新API呼び出し
      const response: AxiosResponse<void | ErrorResponse> = await this.api.update計画書データ表示設定(
        this.計画書.pk,
        request
      );
      if (this.isValidationErrorResponse(response)) return;
      // storage/observableの計画書を更新し、親タブへ受け渡し
      const v計画書: 計画書データListItemResponse = {
        ..._.cloneDeep(this.計画書),
        ...request,
      };
      this.post計画書ToParentTab(v計画書);
    },
  },
});
